/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import { SectionName, SectionTitle } from '../common/styles';

const Container = styled.div`
  margin: ${props => (props.theme.isMobile ? '67px 0 19px 19px' : '0 auto')};
  padding-bottom: 6px;
  max-width: 1230px;
  width: 85vw;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const Timestamp = styled(SectionName)`
  font-size: 12px;
`;

export const Title = styled(SectionTitle)`
  margin: 6px 0 0 0;
  border-bottom: 1px dashed ${props => props.theme.primaryColor};
  font-size: ${props => (props.theme.isMobile ? 25 : 40)}px;
`;

export const Section = styled.div`
  max-width: 1180px;
  width: 82vw;
  font-size: 16px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: start;
  line-height: 25px;
`;

export const InnerSection = styled(Section)`
  max-width: 1120px;
`;

export const Paragraph = styled.p`
  position: relative;
  max-width: 449px;
  margin-top: 24px;
  color: ${props => props.theme.bodyColor};
  font-size: 20px;
  line-height: 25px;
  text-align: left;
`;

export const Intro = styled(Paragraph)`
  max-width: 1180px;
  font-size: 16px;
  margin-top: 44px;
`;

export const Headline = styled(Paragraph)`
  max-width: 1180px;
  width: 82vw;
  font-size: 20px;
  font-weight: ${props => props.theme.fontWeightBold};
  margin-top: 33px;
`;

export const SubHeadline = styled(Paragraph)`
  max-width: 1180px;
  width: 82vw;
  font-size: 18px;
`;

export default function Content() {
  return (
    <Container>
      <Title>
        Legal
      </Title>

      <Section>
        At Livewire Markets and Market Index, we value transparency and want you to have
        easy access to all the essential legal information that governs our relationship. This
        applies to our valued members, readers, partners, advertisers, and anyone who visits our
        websites or engages with our services. We encourage you to review these documents carefully
        to understand your rights and obligations when using our services. If you have any
        questions, please don&apos;t hesitate to contact us.
      </Section>

      <Headline>For Partners</Headline>
      <Section>
        <a href="/company/livewire_advertising_agreement">
          General Terms - Advertising -
          Livewire Markets
        </a>
      </Section>
      <Section>
        <a href="/company/marketindex_advertising_agreement">
          General Terms - Advertising - Market Index
        </a>
      </Section>
      <Section>
        <a href="/company/livewire_general_terms">Livewire General Terms</a>
      </Section>

      <Headline>For Everyone</Headline>

      <Section>
        <a href="/company/terms_and_conditions">Terms & Conditions</a>
      </Section>
      <Section>
        <a href="/company/house_rules">House Rules</a>
      </Section>
      <Section>
        <a href="/company/privacy">Privacy Policy</a>
      </Section>
      <Section>
        If you have any questions, please don&apos;t hesitate to contact us.
      </Section>
    </Container>
  );
}
